<template>
  <v-row align="center">
    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline">{{ title }} Program</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form lazy-validation autocomplete="off">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="program.title"
                    :error="$v.program.title.$error"
                    hide-details
                    outlined
                    dense
                  >
                    <template v-slot:label>
                      Title <span class="text-danger">*</span>
                    </template>
                  </v-text-field>
                  <span class="text-danger" v-if="$v.program.title.$error"
                    >This Field is required</span
                  >
                </v-col>

                <v-col cols="12">
                  <v-select
                    v-model="program.faculty_id"
                    :items="faculties"
                    item-text="title"
                    item-value="id"
                    hide-details
                    :error="$v.program.faculty_id.$error"
                    outlined
                    dense
                  >
                    <template v-slot:label>
                      Faculty <span class="text-danger">*</span>
                    </template>
                  </v-select>
                  <span class="text-danger" v-if="$v.program.faculty_id.$error"
                    >This Field is required</span
                  >
                </v-col>

                <v-col cols="12">
                  Status
                  <v-switch
                    v-model="program.is_active"
                    :label="program.is_active ? 'Yes' : 'No'"
                    outlined
                    dense
                  ></v-switch>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" dark @click="createOrUpdate">
            {{ edit ? "Update" : "Save" }}
          </v-btn>
          <v-btn color="red darken-1" dark @click="closeDialog"> Cancel </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import ProgramService from "@/service/program/ProgramService";
import FacultyService from "@/service/faculty/FacultyService";

const program = new ProgramService();
const faculty = new FacultyService();

export default {
  name: "CreateAndUpdate",
  data() {
    return {
      dialog: false,
      edit: false,
      faculties: [],
      errors: [],
      program: {
        title: "",
        faculty_id: "",
        is_active: true
      }
    };
  },
  validations: {
    program: {
      title: { required },
      faculty_id: { required }
    }
  },
  mounted() {
    this.getAllFaculties();
  },
  computed: {
    title() {
      if (this.edit) {
        return "Edit";
      } else {
        return "Create";
      }
    }
  },
  methods: {
    getAllFaculties() {
      faculty
        .all()
        .then(response => {
          this.faculties = response.data.data;
        })
        .catch(() => {});
    },
    openDialog() {
      this.dialog = true;
      this.edit = false;
      this.resetForm();
    },
    editDialog(program) {
      this.dialog = true;
      this.edit = true;
      this.resetForm();
      this.program = program;
    },
    closeDialog() {
      this.dialog = false;
      this.resetForm();
    },
    resetForm() {
      this.$v.$reset();
      this.program = {
        title: "",
        faculty_id: "",
        is_active: true
      };
    },
    createOrUpdate() {
      this.$v.$touch();
      if (this.$v.$error) {
        setTimeout(() => {
          this.$v.$reset();
        }, 6000);
      } else {
        if (this.edit) {
          program
            .update(this.program.id, this.program)
            .then(response => {
              if (response.data.status === "OK") {
                this.$snotify.success("Program updated successfully");
                this.$emit("refresh");
                this.closeDialog();
              }
            })
            .catch(error => {
              this.errors = error.response.data.errors;
            });
        } else {
          program
            .store(this.program)
            .then(response => {
              if (response.data.status === "OK") {
                this.$snotify.success("Program created successfully");
                this.$emit("refresh");
                this.closeDialog();
              }
            })
            .catch(error => {
              this.errors = error.response.data.errors;
            });
        }
      }
    }
  }
};
</script>
